export const blockIconsBusinessandpaymentsMonetizationOnNew = (
	<span className='material-symbols-outlined'>monetization_on</span>
);
